import store from '@/store/store';
import { ConfigType } from '@/views/questionSets/components/InputTypesConfig';
export class inputControl {
  id: string = ''
  name: string = ''
  entity?: BaseEntityProps
}

export default class Question {
  id: number | null = null;
  question: string = '';
  expiry: number = 0;
  required: boolean | null = null;
  inputControl: inputControl | undefined = undefined;
  additionalTerms: string = '';
  entity?: BaseEntityProps;
  config: ConfigType | null  = null;
  preventCondition: string | null = null;
  [propName: string]: any;

  constructor (o?: Question) {
    if (o) {
      this.id = o.id;
      this.question = o.question;
      this.expiry = isNaN(o.expiry) ? 0 : Number(o.expiry);
      this.required = o.required ;
      this.inputControl = o.inputControl;
      this.additionalTerms = o.additionalTerms;
      this.entity = o.entity;
      this.config = o.config ? JSON.parse(o.config as string) : null;
      this.preventCondition = o.preventCondition;
    }
  }

  get expiryOptions (): Array<{label: string, value: number | null}> {
    return [
      {
        label: 'At every check in',
        value: 0
      }, {
        label: 'At least every hour',
        value: 60
      }, {
        label: 'At least every 24 hours',
        value: 1440
      }, {
        label: 'At least every week hours',
        value: 10080
      }, {
        label: "If induction has expired",
        value: store.state.QUESTION_EXPIRY_INDUCTION_EXPIRED,
      }, {
        label: 'Other',
        value: null
      }
    ]
  }

  get textEditorOptions (): Array<any> {
    return [
      ['bold', 'italic', 'underline'],
      ['link'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [
        { align: '' },
        { align: 'center' },
        { align: 'right' }
      ],
      ['clean']
    ]
  }
}
